import { IconNameType } from '@app/components/ui/icons/icon-name.type';
import { QmUsersRolesListType } from '@app/interfaces/qm-users.type';
import { NavigationRoute, navigationRoutes, NavigationRoutes } from '@app/utils/navigation-routes';
import { userPermissions } from '@app/utils/user-permissions';

export type MenuBarItem = {
  id: number;
  name: string;
  icon: IconNameType;
  iconSize?: number;
  iconSizeHidden?: number;
  routeEnd?: boolean;
  route: NavigationRoutes[NavigationRoute];
  tag?: string;
  soon?: boolean;
};
export type MenuBarList = {
  id: number;
  title?: string;
  menuItems: Array<MenuBarItem>;
};

export type MenuSecondBarList = {
  id: number;
  name: string;
  routeEnd?: boolean;
  route: NavigationRoutes[NavigationRoute];
};

export const menuBarData = [
  {
    id: 1,
    title: 'main',
    menuItems: [
      {
        id: 1,
        name: 'dashboard',
        icon: 'HomeIcon',
        route: navigationRoutes.main,
        routeEnd: true,
        tag: userPermissions.display.displayDashboards,
      },
      {
        id: 2,
        name: 'all_records',
        icon: 'PlayCircleIcon',
        route: navigationRoutes.records,
        tag: userPermissions.display.displayRecords,
      },
      {
        id: 38,
        name: 'all_chats',
        icon: 'PlayCircleIcon',
        route: navigationRoutes.allChats,
        soon: false,
        tag: userPermissions.display.displayChatsProjects,
      },
    ],
  },
  {
    id: 2,
    title: 'analytic_title',
    menuItems: [
      {
        id: 3,
        name: 'analytic_proj',
        icon: 'FolderIcon',
        route: navigationRoutes.analytics,
        tag: userPermissions.display.displayProjects,
      },
      {
        id: 4,
        name: 'proj_records',
        icon: 'FolderMediaIcon',
        route: navigationRoutes.projectRecords,
        tag: userPermissions.display.displayProjects,
      },
      {
        id: 5,
        name: 'reports',
        icon: 'MetricIcon',
        route: navigationRoutes.reports,
        tag: userPermissions.display.displayLiveReports,
      },
      {
        id: 13,
        name: 'words_n_gramm',
        icon: 'CloudIcon',
        route: navigationRoutes.wordsNGramm,
        tag: userPermissions.display.displayLiveReports,
      },
      // {
      //   id: 12,
      //   name: 'words_cloud',
      //   icon: 'CloudIcon',
      //   route: navigationRoutes.wordsCloud,
      // },
    ],
  },
  {
    id: 22,
    title: 'chat_analytic',
    menuItems: [
      {
        id: 3,
        name: 'analytic_proj',
        icon: 'FolderIcon',
        route: navigationRoutes.chatAnalytic,
        tag: userPermissions.display.displayChatsProjects,
      },
      {
        id: 4,
        name: 'proj_records',
        icon: 'FolderMediaIcon',
        route: navigationRoutes.chatProjectRecords,
        tag: userPermissions.display.displayChatsProjects,
      },
      {
        id: 5,
        name: 'reports',
        icon: 'MetricIcon',
        route: navigationRoutes.chatReports,
        tag: userPermissions.display.displayChats,
      },
      {
        id: 13,
        name: 'words_n_gramm',
        icon: 'CloudIcon',
        route: navigationRoutes.chatWordsNGramm,
        tag: userPermissions.display.displayChats,
      },
    ],
  },
  {
    id: 50,
    title: 'qm_module',
    menuItems: [
      {
        id: 53,
        name: 'statistic_section',
        icon: 'ChartIcon',
        route: navigationRoutes.qm_module_statistic,
        qmRoleAccess: ['controller', 'manager', 'operator', 'supervisor'] as QmUsersRolesListType[],
        tag: userPermissions.display.displayQMStats,
      },
      {
        id: 63,
        name: 'qm_manage_monitoring_tasks',
        icon: 'DocInDocIcon',
        route: navigationRoutes.qm_manage_monitoring_tasks,
        qmRoleAccess: ['controller', 'manager'] as QmUsersRolesListType[],
        tag: userPermissions.display.displayMFTasks,
      },
      {
        id: 54,
        name: 'appeal_section',
        icon: 'BellIcon',
        route: navigationRoutes.qm_module_appeal,
        qmRoleAccess: ['controller', 'manager', 'operator', 'supervisor'] as QmUsersRolesListType[],
        tag: userPermissions.display.displayQMAppellation,
      },
      {
        id: 64,
        name: 'qm_manage_monitoring_forms',
        icon: 'DocumentIcon',
        route: navigationRoutes.qm_manage_monitoring_forms,
        qmRoleAccess: ['manager'] as QmUsersRolesListType[],
        tag: userPermissions.display.displayQMMforms,
      },
      {
        id: 65,
        name: 'qm_manage_commands',
        icon: 'Person3Icon',
        route: navigationRoutes.qm_manage_commands,
        qmRoleAccess: ['manager'] as QmUsersRolesListType[],
        tag: userPermissions.display.displayQMTeams,
      },
      {
        id: 66,
        name: 'qm_manage_assessment_templates',
        icon: 'RectangleListIcon',
        route: navigationRoutes.qm_manage_assessment_templates,
        qmRoleAccess: ['manager'] as QmUsersRolesListType[],
        tag: userPermissions.display.displayRSTemplates,
      },
      // {
      //   id: 55,
      //   name: 'qm_manage_section',
      //   icon: 'ChartIcon',
      //   route: `${navigationRoutes.qm_module_manage}/${navigationRoutes.qm_manage_monitoring_forms}`,
      //   // tag: userPermissions.display.displayChats,
      // },
    ],
  },
  {
    id: 73,
    title: 'templates_title',
    menuItems: [
      {
        id: 6,
        name: 'presets_templates',
        icon: 'MenuSmallIcon',
        route: navigationRoutes.presets,
        tag: userPermissions.display.displayProjectPreset,
      },

      {
        id: 8,
        name: 'metrics_templates',
        icon: 'TemplateListIcon',
        route: navigationRoutes.metric,
        tag: userPermissions.display.displayMetricTemplates,
      },
    ],
  },
  {
    id: 54,
    title: 'settings_title',
    menuItems: [
      {
        id: 9,
        name: 'dictionaries',
        icon: 'BookIcon',
        route: navigationRoutes.dictionaries,
        tag: userPermissions.display.displayDictionaries,
      },
      {
        id: 10,
        name: 'system_settings',
        icon: 'SettingIcon',
        route: navigationRoutes.settings,
        tag: userPermissions.display.displaySettings,
      },
      {
        id: 11,
        name: 'audit_logs',
        icon: 'BookOpenIcon',
        route: navigationRoutes.auditLogs,
        tag: userPermissions.display.displayAuditLogs,
      },
      {
        id: 14,
        name: 'users',
        icon: 'UserIcon',
        route: navigationRoutes.users,
        tag: userPermissions.display.displayUsers,
      },
    ],
  },
];

export const secondMenuList: Array<MenuSecondBarList> = [
  {
    id: 1,
    name: 'Speech Analytics',
    routeEnd: true,
    route: navigationRoutes.main,
  },
  {
    id: 2,
    name: 'Text-to-Speech',
    routeEnd: false,
    route: navigationRoutes.reports,
  },
  {
    id: 3,
    name: 'Assist Superviser',
    routeEnd: false,
    route: navigationRoutes.records,
  },
  {
    id: 4,
    name: 'Assist Conf',
    routeEnd: false,
    route: navigationRoutes.presets,
  },
];
